"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.PolicyCard = void 0;
var core_ui_1 = require("@newfront-insurance/core-ui");
var coverage_api_1 = require("@newfront-insurance/coverage-api");
var react_1 = __importDefault(require("react"));
var render_policy_name_1 = __importDefault(require("../../utils/render-policy-name"));
var policy_definition_list_1 = require("../policy-definition-list");
function PolicyCard(_a) {
    var _b;
    var policy = _a.policy, href = _a.href, accountHref = _a.accountHref, onAccountClick = _a.onAccountClick, _c = _a.selectType, selectType = _c === void 0 ? 'checkbox' : _c, target = _a.target, _d = _a.isExpandable, isExpandable = _d === void 0 ? false : _d, _e = _a.defaultExpanded, defaultExpanded = _e === void 0 ? false : _e, isSelected = _a.isSelected, onClick = _a.onClick, onSelect = _a.onSelect, onRemove = _a.onRemove, variant = _a.variant;
    var details = policy.details, definition = policy.definition, type = policy.type, status = policy.status;
    var badgeType;
    var badgeText;
    switch (status) {
        case coverage_api_1.PolicyStatus.ACTIVE:
            badgeText = 'Active';
            badgeType = 'success';
            break;
        case coverage_api_1.PolicyStatus.CANCELLED:
            badgeText = 'Cancelled';
            badgeType = 'danger';
            break;
        case coverage_api_1.PolicyStatus.EXPIRED:
            badgeText = 'Expired';
            badgeType = 'info';
            break;
        case coverage_api_1.PolicyStatus.UPCOMING:
            badgeText = 'Upcoming';
            badgeType = 'warning';
            break;
        default:
            badgeText = undefined;
            badgeType = undefined;
    }
    return (react_1.default.createElement(core_ui_1.FeaturedCard, { eyebrow: "Policy", title: render_policy_name_1.default((_b = definition === null || definition === void 0 ? void 0 : definition.readableName) !== null && _b !== void 0 ? _b : type, details.displayName), href: href, onClick: onClick, target: target, content: react_1.default.createElement(policy_definition_list_1.PolicyDefinitionList, { policy: policy, accountHref: accountHref, onAccountClick: onAccountClick, hideTitle: variant === 'short' }), badge: badgeType ? react_1.default.createElement(core_ui_1.Badge, { type: badgeType }, badgeText) : null, isExpandable: isExpandable, defaultExpanded: defaultExpanded, onSelect: onSelect ? function () { return onSelect(policy); } : undefined, onRemove: onRemove ? function () { return onRemove(policy); } : undefined, isSelected: isSelected, selectType: selectType }));
}
exports.PolicyCard = PolicyCard;
